import script from "./proportionChart.vue?vue&type=script&setup=true&lang=js"
export * from "./proportionChart.vue?vue&type=script&setup=true&lang=js"

import "./proportionChart.vue?vue&type=style&index=0&id=3b57bf1a&scoped=true&lang=css"

import exportComponent from "/jenkins/workspace/rk-storeroom-webui_feature_1.0.1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b57bf1a"]])

export default __exports__